// client/plugins/gtag.client.js

const GA_ID = 'G-H3QSY1ZC7E'

function isProductionHost() {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  // 상용 도메인
  return host === 'infostock.co.kr'
}
// GA 스크립트 로드
function loadGtagScript() {
  if (document.getElementById('gtag-js')) {
    return
  }
  const script = document.createElement('script')
  script.id = 'gtag-js'
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`

  script.onload = () => { console.info('gtag.js 로드 완료') }
  script.onerror = (event) => { console.warn('gtag.js 로드 실패', event) }
  document.head.appendChild(script)
}

export default ({ app }) => {
  // infostock.co.kr이 아니면 GA 실행 안 함
  if (!isProductionHost()) {
    return
  }
  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments)
  }
  loadGtagScript()
  window.gtag('js', new Date())
  // 최초 진입 페이지 집계
  window.gtag('config', GA_ID, {
    page_path: app.router.currentRoute.fullPath,
  })
  // 라우팅 이동 집계
  app.router.afterEach((to) => {
    window.gtag('config', GA_ID, {
      page_path: to.fullPath,
    })
  })
}